var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import Navigation from '../model/Navigation';
import qs from 'querystring';
import transformNavigation from './transformNavigation';
export default transformNavigation(function (navigation) {
  var to = navigation.to;

  if (to) {
    var query = typeof to.search === 'string' && to.search.length > 1 ? qs.parse(to.search.substr(1)) : {};
    return new Navigation(_extends({}, navigation, {
      to: _extends({}, to, {
        query: query
      })
    }));
  }

  return navigation;
});